import CTASection from "../components/CTASection";
import RiskWarning from "../components/RiskWarning";

export default function CommissionDisclosure() {
  const commissionData = [
    { category: "Equity Schemes (Multi Cap)", upfront: "0.0%", year1: "Upto 1.35%", year2: "Upto 1.35%" },
    { category: "Equity Schemes (Large Cap)", upfront: "0.0%", year1: "Upto 1.05%", year2: "Upto 1.05%" },
    { category: "Equity Schemes (Large & Mid Cap)", upfront: "0.0%", year1: "Upto 1.15%", year2: "Upto 1.15%" },
    { category: "Equity Schemes (Mid Cap)", upfront: "0.0%", year1: "Upto 1.25%", year2: "Upto 1.25%" },
    { category: "Equity Schemes (Small Cap)", upfront: "0.0%", year1: "Upto 1.35%", year2: "Upto 1.35%" },
    { category: "Equity Schemes (Dividend Yield, Value, Contra, Focused, Sectoral/Thematic)", upfront: "0.0%", year1: "Upto 1.35%", year2: "Upto 1.35%" },
    { category: "Equity Schemes (ELSS)", upfront: "0.0%", year1: "Upto 1.00%", year2: "Upto 1.00%" },
    { category: "Debt Schemes (Overnight, Liquid)", upfront: "0.0%", year1: "Upto 0.15%", year2: "Upto 0.15%" },
    { category: "Debt Schemes (Ultra Short Duration, Low Duration, Money Market)", upfront: "0.0%", year1: "Upto 0.25%", year2: "Upto 0.25%" },
    { category: "Debt Schemes (Short Duration)", upfront: "0.0%", year1: "Upto 0.40%", year2: "Upto 0.40%" },
    { category: "Debt Schemes (Medium Duration, Medium to Long Duration)", upfront: "0.0%", year1: "Upto 0.75%", year2: "Upto 0.75%" },
    { category: "Debt Schemes (Long Duration, Dynamic Bond)", upfront: "0.0%", year1: "Upto 1.00%", year2: "Upto 1.00%" },
    { category: "Debt Schemes (Corporate Bond, Credit Risk, Banking and PSU)", upfront: "0.0%", year1: "Upto 0.75%", year2: "Upto 0.75%" },
    { category: "Debt Schemes (Gilt)", upfront: "0.0%", year1: "Upto 0.75%", year2: "Upto 0.75%" },
    { category: "Debt Schemes (Floater)", upfront: "0.0%", year1: "Upto 0.50%", year2: "Upto 0.50%" },
    { category: "Hybrid Schemes (Conservative Hybrid)", upfront: "0.0%", year1: "Upto 0.75%", year2: "Upto 0.75%" },
    { category: "Hybrid Schemes (Balanced Hybrid)", upfront: "0.0%", year1: "Upto 1.00%", year2: "Upto 1.00%" },
    { category: "Hybrid Schemes (Aggressive Hybrid)", upfront: "0.0%", year1: "Upto 1.25%", year2: "Upto 1.25%" },
    { category: "Hybrid Schemes (Dynamic Asset Allocation, Multi Asset Allocation)", upfront: "0.0%", year1: "Upto 1.00%", year2: "Upto 1.00%" },
    { category: "Hybrid Schemes (Arbitrage)", upfront: "0.0%", year1: "Upto 1.00%", year2: "Upto 1.00%" },
    { category: "Hybrid Schemes (Equity Savings)", upfront: "0.0%", year1: "Upto 0.85%", year2: "Upto 0.85%" },
    { category: "Other Schemes (Index Funds/ETFs)", upfront: "0.0%", year1: "Upto 0.50%", year2: "Upto 0.50%" },
    { category: "Other Schemes (Funds of Funds)", upfront: "0.0%", year1: "Upto 0.10%", year2: "Upto 0.10%" },
  ];

  return (
    <div id="main-content" className="pt-20" data-testid="commission-disclosure-page">
      <section className="py-32 px-4 sm:px-6 lg:px-8">
        <div className="max-w-6xl mx-auto">
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-4 text-gray-100" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
            Commission Disclosure
          </h1>
          <p className="text-sm text-gray-400 mb-8 uppercase tracking-wider">
            For Distribution of Mutual Fund Products
          </p>

          <div className="space-y-8 text-gray-300">
            <div className="p-6 bg-[#0f0f0f] border border-gray-800 rounded-lg">
              <p className="text-gray-400 mb-6">
                Details of the category-wise commission earned by Kredere Family Office Private Limited from various Asset Management Companies are as follows:
              </p>

              <div className="overflow-x-auto">
                <table className="w-full text-sm">
                  <thead>
                    <tr className="border-b border-gray-700">
                      <th className="text-left py-3 px-4 font-semibold text-[#d4af69]">Category</th>
                      <th className="text-right py-3 px-4 font-semibold text-[#d4af69]">Upfront</th>
                      <th className="text-right py-3 px-4 font-semibold text-[#d4af69]">Year 1 Trail</th>
                      <th className="text-right py-3 px-4 font-semibold text-[#d4af69]">Year 2+ Trail</th>
                    </tr>
                  </thead>
                  <tbody>
                    {commissionData.map((row, index) => (
                      <tr key={index} className="border-b border-gray-800 hover:bg-[#1a1410]/30 transition-colors">
                        <td className="py-3 px-4 text-gray-300">{row.category}</td>
                        <td className="py-3 px-4 text-right text-gray-400">{row.upfront}</td>
                        <td className="py-3 px-4 text-right text-gray-400">{row.year1}</td>
                        <td className="py-3 px-4 text-right text-gray-400">{row.year2}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            <div className="p-6 bg-[#0f0f0f] border border-gray-800 rounded-lg">
              <h2 className="text-2xl font-semibold mb-4 text-[#d4af69]">Important Disclaimers</h2>
              <ul className="space-y-3 text-gray-400 text-sm">
                <li className="flex items-start gap-2">
                  <span className="text-[#d4af69] mt-1">•</span>
                  <span>The above commission rates are updated on a best-effort basis. While we strive to keep this information current, there may be delays in reflecting the latest rates.</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-[#d4af69] mt-1">•</span>
                  <span>Investors are advised to verify commission details directly with their distributor or the Asset Management Company before making investment decisions.</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-[#d4af69] mt-1">•</span>
                  <span>Kredere Family Office Private Limited may receive reimbursement of expenses from AMCs as per regulatory guidelines.</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-[#d4af69] mt-1">•</span>
                  <span>Commission rates are subject to change at the discretion of Asset Management Companies and as per regulatory provisions.</span>
                </li>
              </ul>
            </div>

            <CTASection />

            <RiskWarning />
          </div>
        </div>
      </section>
    </div>
  );
}
